import { CalendarData } from "../defs";

export default function isAnyDayBlackedOut(calendarData: CalendarData, checkInDate: Date, checkOutDate: Date): boolean {
  let currentDate = new Date(checkInDate);
  while (currentDate < checkOutDate) {
    const dateStr = window.pepDateFunctions.formatDateObjectYYYYMMDD(currentDate);
    const dateYearMonth = dateStr.split('-').slice(0, 2).join('-');
    const dateDay = dateStr.split('-')[2];

    if (
      dateYearMonth in calendarData
      && dateDay in calendarData[dateYearMonth]
      && calendarData[dateYearMonth][dateDay].BLACKOUT
    ) {
      return true;
    }
    currentDate = window.pepDateFunctions.addDays(currentDate, 1);
  }

  return false;
};